// src/store/auth.js
import {login, getUserPermissions} from '@/api/user'
import router from '@/router';
import { Message } from 'element-ui';
export default {
  state: {
    isAuthenticated: localStorage.getItem('token') !== null,
    userName: localStorage.getItem('userName') || '',
    userRole: localStorage.getItem('userRole') || '',
    allowedPaths: JSON.parse(localStorage.getItem('allowedPaths') || 'null'),
  },
  mutations: {
    async login(state,loginInfo) {
      const res = await login({
        ...loginInfo,
        loginType: 'app'
      })
      if(res.code == 200) {

          state.isAuthenticated = true;
          state.userName = res.data.UserName || res.data.userName || '';
          state.userRole = res.data.Role || res.data.role || 'user'
          state.userName = res.data.UserName || res.data.userName || '';
          state.userRole = res.data.Role || res.data.role || 'user'
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userName', res.data.UserName);
          localStorage.setItem('userRole', state.userRole);
          
          // 获取用户权限路径
          try {
            const permissionsRes = await getUserPermissions();
            console.log('权限接口响应:', permissionsRes);
            if(permissionsRes.code == 200) {
              state.allowedPaths = permissionsRes.data.allowedPaths || permissionsRes.data;
              localStorage.setItem('allowedPaths', JSON.stringify(state.allowedPaths));
            } else {
              console.log('权限接口返回错误:', permissionsRes.message);
            }
          } catch(error) {
            console.log('获取权限失败，使用默认配置:', error);
          }
          
          router.push('/module-selection')
      }
    },
    logout(state) {
      state.isAuthenticated = false;
      state.userRole = '';
      state.allowedPaths = null;
      localStorage.removeItem('token');
      localStorage.removeItem('userName');
      localStorage.removeItem('userRole');
      localStorage.removeItem('allowedPaths');
      router.push('/login')
    },
    setAllowedPaths(state, allowedPaths) {
      state.allowedPaths = allowedPaths;
      localStorage.setItem('allowedPaths', JSON.stringify(allowedPaths));
    },
    async initPermissions(state) {
      // 如果用户已登录但没有权限数据，尝试获取权限
      if (state.isAuthenticated && !state.allowedPaths) {
        try {
          const permissionsRes = await getUserPermissions();
          if(permissionsRes.code == 200) {
            state.allowedPaths = permissionsRes.data.allowedPaths || permissionsRes.data;
            localStorage.setItem('allowedPaths', JSON.stringify(state.allowedPaths));
          }
        } catch(error) {
          console.log('初始化权限失败:', error);
        }
      }
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    userName: state => state.userName,
    userRole: state => state.userRole,
    allowedPaths: state => state.allowedPaths
  }
};